import { MonitorSmartphone, ParkingMeter, ShieldCheck, Car } from 'lucide-react';
import CategoryTemplate from '../components/CategoryTemplate';
import { getRelated } from '../data/serviceCatalog';

const ParkingSystem = () => {
  const trustPoints = [
    { Icon: MonitorSmartphone, label: '満車・空車 案内表示' },
    { Icon: ParkingMeter, label: '料金・時間表示に対応' },
    { Icon: Car, label: '出入口設備を一式で対応' },
    { Icon: ShieldCheck, label: '屋外設置に耐える設計' },
  ];

  const types = [
    { title: '満空表示板', desc: '「空」「満」表示による駐車場入口案内。' },
    { title: '駐車場料金表示板', desc: '料金・時間・案内をまとめて表示する看板。' },
    { title: '駐車場案内看板', desc: '駐車場名・案内表示・料金表示などを掲載する看板。' },
    { title: '出入口ゲート機器', desc: '車両出入口の管理機器(お問い合わせに応じて選定)。' },
    { title: '防犯カメラ連携', desc: '出入口・場内の防犯カメラ・録画機器の統合構成。' },
    { title: 'LED照明との組み合わせ', desc: '駐車場全体の視認性・安全性を高めるLED照明との併用。' },
  ];

  const process = [
    { title: 'ヒアリング', desc: '駐車場の規模・運営方式・希望の設備をお伺いします。' },
    { title: '現地調査', desc: 'レイアウト・入出庫台数・電源経路・視認範囲を確認します。' },
    { title: '仕様・見積提出', desc: '機器構成・表示レイアウトとお見積りをご提出します。' },
    { title: '製作・施工', desc: '運用スケジュールに合わせて機器の製作と現場施工を行います。' },
  ];

  return (
    <CategoryTemplate
      id="parking-system"
      eyebrow="PARKING SYSTEM"
      name="パーキングシステム"
      description="駐車場入口の満空表示、料金表示、案内看板、車両出入口まわりの設備を一式でご提案します。運営の負担を減らし、利用者にとって分かりやすい駐車場を構築します。"
      tags={['満空表示', '料金・案内表示', '出入口設備', '屋外対応', 'カメラ連携']}
      heroImage="/images/services/parking.png"
      trustPoints={trustPoints}
      types={types}
      processSteps={process}
      relatedServices={getRelated(['electric-board', 'security-camera', 'led-lighting'])}
    />
  );
};

export default ParkingSystem;
